module.exports = __webpack_public_path__ + "img/parkway-brewing-co.2c369c52.jpeg";